import { Component, ElementRef, Input, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { DialogComponent } from "src/app/features-common/components/dialog/dialog.component";
import { TranslateConfigService } from "src/app/features-common/services/translate-config.service";
import { ROUTES } from "../layout.component";
import {
  Location,
  LocationStrategy,
  PathLocationStrategy,
} from "@angular/common";
import { LoginService } from "../services/login.service";
import { JwtHelperService } from "@auth0/angular-jwt";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { Message } from "@stomp/stompjs";
import { Subscription } from "rxjs";
import { ConfigValuesService } from "src/app/features-common/services/config-values.service";
const helper = new JwtHelperService();

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  @Input() showTopbar: boolean;
  @Input() showinner: boolean;
  private listTitles: any[];
  location: Location;
  mobile_menu_visible: any = 0;
  private toggleButton: any;
  private sidebarVisible: boolean;
  userName: any;
  preferredLanguage: any;
  messageSubscription: Subscription;
  messages: any = [];
  messagesCount: number = 0;
  connectedPlatform: any;
  connectionFlag: boolean;
  showConnectionService: any;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private translateService: TranslateConfigService,
    location: Location,
    private element: ElementRef,
    private loginService: LoginService,
    private uiConfigService: ConfigValuesService
  ) {
    super();
    this.location = location;
    this.sidebarVisible = false;
    this.getConnectedPlatform()
    this.uiConfigService.getUIConfigValues('Enable Connected').subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.showConnectionService = resData[0];
      }
    })
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (!this.isUserLoggedIn()) {
      this.preferredLanguage = this.hasLangSelection() ? localStorage.getItem('PrefLang') : "en"
      return
    }
    if (this.isUserLoggedIn) {
      const decodedToken = helper.decodeToken(localStorage.getItem("accessToken"));
      const userId = decodedToken.user_id;
      console.log(`From app header`);

      this.rxStompService.activate();
      console.log(`If the client is active (connected or going to reconnect).`);
      console.log(this.rxStompService.active);
      console.log(`Stomp broker connection status: ${this.rxStompService.connected}`);
      console.log(`Stomp Errors`);
      console.log(this.rxStompService.stompErrors$);

      this.messageSubscription = this.rxStompService
        .watch(`/user/${userId}/subscribe`)
        .subscribe((message: Message) => {
          this.messages.push(message.body);
          this.messagesCount = this.messages?.length;
        });
        this.httpService.get('api/v1/messages/unread').subscribe(res => {
          if(res['httpcode'] == 200){
            this.messagesCount = res['data'];
          }
        })
        


      this.userName = decodedToken.sub;
      //this.preferredLanguage = decodedToken.preferredLanguage && decodedToken.preferredLanguage ? decodedToken.preferredLanguage : "en";
      //this.translateService.changeLanguage(this.preferredLanguage);

      this.preferredLanguage = this.hasLangSelection() && localStorage.getItem('LangChange') == 'true' ? localStorage.getItem('PrefLang') : decodedToken.preferredLanguage;
      this.translateService.changeLanguage(this.preferredLanguage);
      localStorage.setItem('PrefLang', this.preferredLanguage)
    }
    // console.log(this.showTopbar);
    this.listTitles = ROUTES.filter((listTitle) => listTitle);
    const navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName("navbar-toggler")[0];
    this.router.events.subscribe((event) => {
      this.sidebarClose();
      var $layer: any = document.getElementsByClassName("close-layer")[0];
      if ($layer) {
        $layer.remove();
        this.mobile_menu_visible = 0;
      }
    });
  }
  hasLangSelection() {
    return localStorage.getItem('PrefLang') && localStorage.getItem('PrefLang') ? true : false;
  }
 
  getConnectedPlatform(){
    let _token = localStorage.getItem("accessToken");
    if (_token && _token) {
      const decodedToken = helper.decodeToken(localStorage.getItem("accessToken"));
      if(decodedToken.role == "Super Admin"){
        this.loginService.getConnectionFlag().subscribe(res => {
          let resData: any = res;
          if (resData.httpcode == 200) {
            resData = resData.data;
            this.connectedPlatform = resData;
            if(this.connectedPlatform=="true"){
              this.connectionFlag=true;
            }else{
              this.connectionFlag=false;
            }
          }
        });
      }
    }
   
  }
  changePlatform(){
    this.connectionFlag=!this.connectionFlag
    this.loginService.putConnections(this.connectionFlag).subscribe((e) => {
      this.getConnectedPlatform()
    });

  }
  
  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.isUserLoggedIn() && this.messageSubscription != undefined) {
      this.messageSubscription.unsubscribe();
    }
  }
  isUserLoggedIn(): boolean {
    let token = localStorage.getItem("accessToken");
    return token && token ? true : false;
  }
  // For xs devices - on toggle menu click
  back() {
    this.location.back();
  }
  sidebarToggle() {
    // const toggleButton = this.toggleButton;
    // const body = document.getElementsByTagName('body')[0];
    var $toggle = document.getElementsByClassName("navbar-toggler")[0];

    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
    const body = document.getElementsByTagName("body")[0];

    if (this.mobile_menu_visible == 1) {
      // $('html').removeClass('nav-open');
      body.classList.remove("nav-open");
      if ($layer) {
        $layer.remove();
      }
      setTimeout(function () {
        $toggle.classList.remove("toggled");
      }, 400);

      this.mobile_menu_visible = 0;
    } else {
      setTimeout(function () {
        $toggle.classList.add("toggled");
      }, 430);

      var $layer = document.createElement("div");
      $layer.setAttribute("class", "close-layer");

      if (body.querySelectorAll(".main-panel")) {
        document.getElementsByClassName("main-panel")[0].appendChild($layer);
      } else if (body.classList.contains("off-canvas-sidebar")) {
        document
          .getElementsByClassName("wrapper-full-page")[0]
          .appendChild($layer);
      }

      setTimeout(function () {
        $layer.classList.add("visible");
      }, 100);

      $layer.onclick = function () {
        //asign a function
        body.classList.remove("nav-open");
        this.mobile_menu_visible = 0;
        $layer.classList.remove("visible");
        setTimeout(function () {
          $layer.remove();
          $toggle.classList.remove("toggled");
        }, 400);
      }.bind(this);

      body.classList.add("nav-open");
      this.mobile_menu_visible = 1;
    }
  }
  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const body = document.getElementsByTagName("body")[0];
    setTimeout(function () {
      toggleButton.classList.add("toggled");
    }, 500);

    body.classList.add("nav-open");

    this.sidebarVisible = true;
  }

  sidebarClose() {
    const body = document.getElementsByTagName("body")[0];
    this.toggleButton.classList.remove("toggled");
    this.sidebarVisible = false;
    body.classList.remove("nav-open");
    //TODO: Fix overlay on close
    body.classList.remove("close-layer");
    body.classList.remove("visible");
  }

  //On Logout click
  onLogout() {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        message: "pages.placeholders.AreYousureyouwanttologout",
        buttonText: {
          ok: "Yes",
          cancel: "No",
        },
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        // alert(`Logout Successful!`);
        this.loginService.logout().subscribe((e) => {
          console.log(e);

          if (e.httpcode == 200) {
            localStorage.clear();
            this.router.navigateByUrl("/logout");
          }
          return;
        });
        localStorage.clear();
        this.router.navigateByUrl("/logout");
        return;
      }
    });
  }
  // On Language Selection
  onChnageLanguage(lang) {
    this.preferredLanguage = lang;
    localStorage.setItem('PrefLang', lang)
    localStorage.setItem('LangChange', 'true')
    this.translateService.changeLanguage(lang);
  }

  brandNavigate() {
    let _token = localStorage.getItem("accessToken");
    if (_token && _token) {
      const decodedToken = helper.decodeToken(localStorage.getItem("accessToken"));
      decodedToken.role == "Customer Service"
        ? this.router.navigate(["features/retailers"])
        : this.router.navigate(["/"]);
      return;
    }
    this.router.navigate(["/"]);
  }
  navigatetoMessages() {
    console.log(this.router.url);
    let currentUrl = '/features/messages';
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }
}
